module.exports = __webpack_public_path__ + "img/nemotron-lepton-job.687acf31.png";